import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AllSalaryAddPopup from "../../../../components/modelpopup/AllSalaryAddPopup";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import SalaryListFilter from "./../components/SalaryListFilter";
import { Table, Pagination,Button, Tooltip,Spin    } from "antd";

import { Button as CustomButton} from "components/Button";

import Image from "components/Image"
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";

import { SkeltonLoader } from "components/skeltonLoader";
import SalaryFilter from "components/Drawer/salaryFilterDrawer";
import { useSalary } from "./../context/salaryContext";
import { getEmployeeSalaryDetailApi } from "api/services/employee"
import { useSelector } from "react-redux";
import { primaryRedGradient } from "utils/constants";
import { useMediaQuery } from "react-responsive";


const AllSalary = () => {
  const {
    loading,
    searchText,
    salaryData,
    view,
    setView,
    salaryModal,
    setSalaryModal,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleSalaryDetailPage,
    handleDateChange,
    handleClearAll,
    isFilterDirty
  } = useSalary();


  const [expandedRows, setExpandedRows] = useState([]);
  const [loadingRow, setLoadingRow] = useState(null); 
  const [salaryDetails, setSalaryDetails] = useState({});

  const {
    user, userLoading   
} = useSelector((state) => state.user);

  const toggleExpand = (record) => {
    if (expandedRows.includes(record.id)) {
      // Collapse the row
      setExpandedRows((prevRows) => prevRows.filter((id) => id !== record.id));
    } else {
      // Get Salary Details for User
      setLoadingRow(record.id);
      getEmployeeSalaryDetailApi(record.company_user?.id).then((response) => {
        
        setSalaryDetails((prevDetails) => ({
          ...prevDetails,
          [record.id]: response.data,
        }));
        setExpandedRows((prevRows) => [...prevRows, record.id]);
        setLoadingRow(null);
      });
    }
  };
  
 


  const renderSalaryDetailColumn = (salaryDetails) => {
    const earnings = salaryDetails.data.filter(item => item.Pay_Purpose === 'Earning');
    const deductions = salaryDetails.data.filter(item => item.Pay_Purpose === 'Deduction'); 
  
    // Separate the included and excluded items for earnings
    const earningsIncluded = earnings.filter(item => !item.Exclude_In_Pay_Slip);
    const earningsExcluded = earnings.filter(item => item.Exclude_In_Pay_Slip);
  
    // Separate the included and excluded items for deductions
    const deductionsIncluded = deductions.filter(item => !item.Exclude_In_Pay_Slip);
    const deductionsExcluded = deductions.filter(item => item.Exclude_In_Pay_Slip);
  
    // Combine excluded earnings and deductions into one list
    const excludedItems = [...earningsExcluded, ...deductionsExcluded];
  
    return (
      <div>
        {/* Render included earnings first */}
        {earningsIncluded.map((item, index) => (
          <div key={index}>
            <strong>{item.Pay_Name}:</strong> AED {(item.Pay_Amount).toFixed(2)}
          </div>
        ))}
  
        {/* Render included deductions */}
        {deductionsIncluded.length > 0 && (
          <div>
            <strong>Deductions:</strong>
            {deductionsIncluded.map((item, index) => (
              <div key={index}>
                {item.Pay_Name}: AED {(item.Pay_Amount).toFixed(2)}
              </div>
            ))}
          </div>
        )}
  
        {/* Render excluded earnings and deductions together at the bottom */}
        {excludedItems.length > 0 && (
          <div>
            {/* <strong>Excluded in PaySlip </strong> */}
            {excludedItems.map((item, index) => (
              <div key={index} >
                  <strong>{item.Pay_Name}:</strong> <span > AED {(item.Pay_Amount).toFixed(2)} </span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };
  
  


  const columns = [
    {
      title: "Emp No",
      dataIndex: "company_user__emp_no",
      width: 96,
      render: (text, record) => (
        <span className="table-avatar">
          {record.company_user.emp_no}
        </span>
      )  ,
       sorter: true
    },
    {
      title: "Employee Name",
      dataIndex: "company_user__first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex align-items-center">
          <a className="avatar">
            <Image src={record.company_user.profile_image} type="user" style={{ objectFit: "cover" }}  />
          </a>
          <div className="d-flex flex-column justify-content-center ms-2">
            <Link
              to={`/employees/${record.company_user?.id}`}
              className="profile-split"
              title="Open employee profile"
              style={{ textDecoration: "underline", textDecorationColor: "#d1d5db", textUnderlineOffset: "3px" }}
            >
              {record.company_user.first_name} {record.company_user.middle_name} {record.company_user.last_name}
            </Link>
          </div>
        </h2>
      ),
    },
    
  
    {
      title: "Designation",
      dataIndex: "company_user__user_employment_company_user__position__name",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.position?.name}
        </span>
      ),
      align:"center"
    
    },
    {
      title: "Cost Center",
      dataIndex: "company_user__cost_center__name",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.cost_center?.name}
        </span>
      ),
      align:"center"
    
    },
    {
      title: "Email",
      dataIndex: "company_user__usercontact_company_user__private_email",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.company_user.email}
        </span>
      )   
    
    },
  
  
    {
      title: "Salary Amount",
      dataIndex: "amount",
      sorter: true,
      render: (text, record) => (
        <div className="d-flex flex-column">
         
          <div className="d-flex justify-content-between align-items-center" style={{ width: "180px" }}>
            <span className="fw-bold">AED {record.amount}</span>
            {record.amount > 0 && <Tooltip title="Show Salary Details">
              <Button
              size="small"
              type="link"
              onClick={() => toggleExpand(record)}
              style={{ minWidth: "80px", textAlign: "center" }}
            >
              {expandedRows.includes(record.id) ? "▲" : "▼"}
            </Button>
            </Tooltip> }
          </div>

       
          {expandedRows.includes(record.id) && (
            <div className="mt-2 p-2 border rounded bg-light">
              {loadingRow === record.id ? (
                <div className="text-center p-2">
                  <Spin size="small" /> <span className="small text-muted">Loading Salary Details...</span>
                </div>
              ) : (
                <>               
                 { renderSalaryDetailColumn(salaryDetails[record.id])}
                </>
              )}
            </div>
          )}
        </div>
      ),
    }, 
    
  ];



  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {salaryData.map((record, index) => (
            <div className="col-xxl-3 col-xl-4 col-md-6">
            <div className="contact-grid">
                <div className="grid-head">
                    <div className="users-profile">
                        <a   className="avatar">
                            {/* <img src={employee?.profile_image} alt="" /> */}
                            <Image  src={record.company_user?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                        </a>
                        <h5 className="name-user">
                            <a   >{record.company_user?.first_name} {record?.company_user?.last_name} </a>
                            <span>{record.company_user?.emp_no} | {record?.position?.name}</span> 
                        </h5>
                    </div>
                 
                </div>
                <div className="grid-body">
                    <div className="address-info">
                    <div className="grid-badges">
                        <span className="badge badge-soft-warning mb-3">{record.cost_center?.name}</span>
                    </div>

                        <span className="w-100 overflow-auto">
                            <i className="la la-envelope" />
                            Email : {record.company_user.email}
                            {/* sharon@gmail.com */}
                        </span>
                        <span>
                            <i className="la la-money" />
                          Amount :  AED {record.amount} {record.amount > 0 && <Tooltip title="Show Salary Details">
                            <Button
                            size="small"
                            type="link"
                            onClick={() => toggleExpand(record)}
                            style={{ minWidth: "80px", textAlign: "center" }}
                          >
                            {expandedRows.includes(record.id) ? "▲" : "▼"}
                          </Button>
                          </Tooltip> }
                        </span>
                       
                    </div>
                    {expandedRows.includes(record.id) && (
            <div className="mt-2 p-2 border rounded bg-light">
              {loadingRow === record.id ? (
                <div className="text-center p-2">
                  <Spin size="small" /> <span className="small text-muted">Loading Salary Details...</span>
                </div>
              ) : (
                <>               
                 { renderSalaryDetailColumn(salaryDetails[record.id])}
                </>
              )}
            </div>
          )}
          
                  
                </div>
               
            </div>
        </div>
          ))}
        </>
      );
    }
  };


  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Employee Salary"
            title="Dashboard"
            subtitle="Salary"
            modal="#add_salary"
            name="Add Salary"          
            view={view}
            setSalaryModal={setSalaryModal}
            setView={setView}
          />
      
          {user.role?.access_scope !== "self" && <div className="row" > <SalaryListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search Data"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          />
          </div> }



          {view == "grid" ? (
            <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination

pageSize={pageSettings?.pageSize}
pageSizeOptions={pageSizeOptions}
defaultCurrent={1}
current={pageSettings?.page}
total={pageSettings?.total}
// itemRender={itemRender}
onChange={handleGridChange}

showLessItems
showSizeChanger={false}
showQuickJumper={false}
hideOnSinglePage
itemRender={(page, type, originalElement) => {
  if (type === "next") {
    return (
      <CustomButton
        loading={loading}
        // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
        className="btn btn-primary "
        // type="Load More"
        label="Load More"
      />
      
    );
  }
  return null;
}}

/>
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <style>{`
                    .modern-table .ant-table-tbody > tr {
                      background-color: #ffffff !important;
                    }
                    .modern-table .ant-table-tbody > tr:hover > td {
                      background-color: #f5f5f5 !important;
                    }
                    .modern-table .ant-table-thead > tr > th {
                      background-color: #f8f9fa !important;
                      font-weight: 600;
                      color: #333;
                      border-bottom: 2px solid #e0e0e0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #f0f0f0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                      border-top: 1px solid #f0f0f0;
                      background-color: #ffffff;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    }
                  `}</style>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={salaryData}
                      rowKey={(record) => record.id}
                      loading={loading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <AllSalaryAddPopup />
      {/* Delete Modal */}
      <DeleteModal Name="Delete Salary" />

      <SalaryFilter
          searchPlaceholder={"Search Salary"}
          showFilterDrawer={showFilterDrawer}
          handleFilterDrawer={handleFilterDrawer}

          handleFilterChange={handleFilterChange}
          filters={filters}
          handleInputChange={handleInputChange}
          handleApplyFilter={handleApplyFilter}
          filterLoading={filterLoading}
          handleDateChange={handleDateChange}
          handleClearAll={handleClearAll}
          isFilterDirty={isFilterDirty}
/>
      {/* Delete Modal */}
    </div>
  );
};

export default AllSalary;
